<template>
  <div class="m-edit-box">
    <div class="bar">
      <div class="tool-box text-overflow">
        <template v-if="reply.id">
          <el-tag :disable-transitions="true" size="mini" @close="clearRevert" closable
            >回复：<span class="text-overflow">{{ reply.txt }}</span>
          </el-tag>
        </template>
        <template v-if="ats.length">
          <el-tag :disable-transitions="true" size="mini" v-for="(item, index) in ats" :key="item.at" @close="clearRevert(index)" closable>
            @{{ item.atName }}
          </el-tag>
        </template>
        <template v-if="showTpye">
          <!--          <el-tabs @tab-click="changeType" v-model="tabIndex">-->
          <!--            <el-tab-pane-->
          <!--              v-for="item in types"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--            ></el-tab-pane>-->
          <!--          </el-tabs>-->
        </template>
      </div>
      <div class="right">
        <el-popover popper-class="emoji-picker" placement="top" v-model="showEmojiPicker" trigger="click">
          <EmojiPicker :on-emoji-picked="onEmojiPicked" />
          <svg-icon style="margin-top: 5px;" name="smile" slot="reference"></svg-icon>
        </el-popover>
        <el-upload :action="uploadUrl" :multiple="false" list-type="picture-card" class="upload-btn" :auto-upload="false" :on-change="handleChange">
          <svg-icon style="margin-top: 5px;" name="picture"></svg-icon>
        </el-upload>
        <template v-if="isPrivate === false">
          <svg-icon style="margin-top: 2px;" name="ai" title="@AI" @click.native="atAI"></svg-icon>
          <quick-btn @click="clickQuickHandle">
            <svg-icon name="add" slot="reference" style="fill: #999;margin-top: 5px;"></svg-icon>
          </quick-btn>
          <el-checkbox :value="isAnonymous" @change="toggleAnonymous">匿名</el-checkbox>
        </template>
        <div @click="sendMessage" class="send-btn">
          发送 {{ tag }}
          <div v-if="isAnonymous !== true" @click.stop="tagsPopVisible = true" style="display: inline-block;padding: 0 5px;margin-right: -10px">
            <el-popover v-if="isPrivate === false" popper-class="tags-popover" v-model="tagsPopVisible" width="100">
              <i style="padding: 0 2px" slot="reference" class="el-icon-arrow-down"></i>
              <div class="tags-box">
                <div @click="clickType(index)" v-for="(item, index) in types" :key="index">
                  {{ item.label }}
                </div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="scroll-box">
      <el-input
        :placeholder="msgType === 5 && '输入公司名，让AI帮您找出TA的资质，信誉，标签等信息！(回车发送)'"
        type="textarea"
        :autosize="{ minRows: 2 }"
        :autofocus="true"
        resize="none"
        ref="input"
        id="input"
        @keydown.native.enter="sendMessage"
        @input="inputHandle"
        v-model="context"
      >
      </el-input>
      <el-upload
        :action="uploadUrl"
        class="upload-box"
        v-show="showUpload"
        :headers="headers"
        :on-success="handleSuccess"
        list-type="picture-card"
        ref="upload"
        :multiple="true"
        :file-list="fileList"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :auto-upload="true"
      >
        <i slot="default" class="el-icon-plus"></i>
      </el-upload>
      <el-dialog width="100%" :visible.sync="dialogVisible" :append-to-body="true" style="z-index: 1">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
    <el-dialog :visible.sync="searchVisible" width="95%" :append-to-body="true" @close="searchVisible = false" custom-class="quick-dialog">
      <search-dialog v-if="searchVisible" :quick-type="quickType" @close="searchVisible = false" :destroy-on-close="false"></search-dialog>
    </el-dialog>
  </div>
</template>
<script>
import EmojiPicker from "@/components/EmojiPicker";
import SearchDialog from "@/components/dialog/Search";
import QuickBtn from "@/components/QuickBtn";
import Tags from "./tags";
import { mapMutations, mapState } from "vuex";

export default {
  name: "EditBox",
  data() {
    return {
      uploading: false,
      tagsPopVisible: false,
      showEmojiPicker: false,
      visible: true,
      context: "",
      tag: "",
      msgType: 0,
      searchVisible: false,
      showUpload: false,
      tabIndex: 0,
      uploadUrl: `${process.env.VUE_APP_BASE_URL}/File/Upload?type=im`,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      fileList: [],
      quickType: {},
      lastModified: []
    };
  },
  computed: {
    ...mapState({ isAnonymous: state => state.isAnonymous }),
    headers() {
      return {
        Authorization: "ErpApi" + this.$store.state.token
      };
    },
    showTpye() {
      if (this.reply && this.reply.id) {
        return false;
      }
      if (this.ats && this.ats.length) {
        return false;
      }
      if (this.types.length === 0) {
        return false;
      }
      return true;
    }
  },
  components: { EmojiPicker, SearchDialog, QuickBtn },
  props: {
    reply: {
      type: Object,
      default() {
        return {};
      }
    },
    isPrivate: {
      type: Boolean,
      default: false
    },
    ats: {
      type: Array,
      default() {
        return [];
      }
    },
    types: {
      type: Array,
      default() {
        const tags = JSON.parse(JSON.stringify(Tags));
        tags.unshift({
          label: "普通消息"
        });
        return tags;
      }
    }
  },
  watch: {
    isAnonymous(newValue) {
      if (newValue === true) {
        this.msgType = 0;
        this.tag = "";
      }
    }
  },
  methods: {
    ...mapMutations(["toggleAnonymous"]),
    atAI() {
      const index = this.ats.findIndex(item => item.at === "f03e129e-096d-47f8-820b-1ba41a1f4ef7");
      if (index === -1) {
        this.ats.push({
          atName: "AI",
          at: "f03e129e-096d-47f8-820b-1ba41a1f4ef7"
        });
        this.msgType = 5;
      }
    },
    inputHandle(event) {
      if (event.endsWith("\n")) {
        this.context = event.substr(0, event.length - 1);
      }
    },
    clickQuickHandle(event) {
      this.searchVisible = true;
      this.quickType = event;
    },
    clearRevert(index) {
      if (typeof index === "number") {
        const ats = JSON.parse(JSON.stringify(this.ats));
        ats.splice(index, 1);
        this.$emit("update:ats", ats);
      } else {
        this.$emit("update:reply", { id: "" });
      }
      this.msgType = 0;
      this.tag = "";
      this.$refs.input.focus();
    },
    // 粘贴上传
    onPasteUpload(e) {
      const upload = this.$refs.upload;
      const items = e.clipboardData.items;
      for (const item of items) {
        if (item.type === "image/png") {
          this.showUpload = true;
          this.uploading = true;
          const file = new File([item.getAsFile()], new Date().getTime() + ".png");
          e.preventDefault();
          if (file.size / 1024 / 1024 > 1) {
            this.$toast.fail("图片大小不能超过1M，或请改用选择文件上传！");
            if (this.fileList.length === 0) {
              this.showUpload = false;
            }
            continue;
          }
          upload.handleStart(file);
          upload.submit();
        }
      }
    },
    handleChange(file) {
      this.showUpload = true;
      this.uploading = true;
      const upload = this.$refs.upload;
      if (file.size > 1024 * 1024) {
        this.$toast.fail("图片大小不能超过1M！");
        if (this.fileList.length === 0) {
          this.showUpload = false;
        }
        return false;
      }
      upload.handleStart(file.raw);
      upload.submit();
    },
    handleSuccess(response, file, fileList) {
      this.uploading = false;
      if (response.data && response.data.length) {
        this.fileList = fileList;
      } else {
        this.$toast.fail(response.logicmsg);
        this.handleRemove(file);
      }
    },
    handleRemove(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid);
      this.fileList.splice(index, 1);
      if (this.fileList.length === 0) {
        this.showUpload = false;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    clickType(index) {
      this.msgType = 0;
      this.ats.length = 0;
      this.tag = "";
      if (index !== 0) {
        this.tag = this.types[index].label;
        this.msgType = 0;
      }
      this.tagsPopVisible = false;
      this.$refs.input.focus();
    },
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    onEmojiPicked(e) {
      this.context += e;
      this.showEmojiPicker = false;
    },
    sendMessage(e) {
      // 换行操作
      if (e.shiftKey) {
        return true;
      }
      if (this.uploading === true) {
        this.$toast("正在上传图片请稍后再试");
        this.uploading = false;
        return false;
      }
      this.context = this.context.trim();
      // if (this.context === "") {
      //   this.$message.error("发送内容不能为空！");
      //   return false;
      // }
      const imgs = [];
      this.fileList.map(item => imgs.push(item.response.data[0]));
      const message = {
        txt: this.context,
        tags: this.tag,
        isAnonymous: this.isAnonymous,
        imgs,
        ats: this.ats
      };
      if (this.reply && this.reply.id) {
        message.reply = this.reply.id;
      }
      this.$emit("send", message);
      // 清空消息框
      this.context = "";
      this.fileList = [];
      this.msgType = 0;
      this.$emit("update:ats", []);
      this.showUpload = false;
    }
  },
  beforeDestroy() {
    document.removeEventListener("paste", this.onPasteUpload);
  },
  mounted() {
    if (this.$store.state.editTxt) {
      this.context = this.$store.state.editTxt;
    }
    document.addEventListener("paste", this.onPasteUpload);
  }
};
</script>
<style lang="scss">
.m-edit-box {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  background: #f9f9f9;
  border-top: 1px solid #dbdbdb;
  .scroll-box {
    padding: 0 8px 8px 8px;
    height: 100%;
    overflow: auto;
  }
  .el-tabs__header {
    margin-bottom: 0;
  }
  .el-tabs {
    padding-left: 10px;
    display: flex;
    align-items: center;
    .el-tabs__nav-wrap::after {
      background-color: transparent;
    }
    .el-tabs__item {
      display: inline-flex;
      align-items: center;
      height: 30px;
      padding: 0 5px;
      font-size: 12px;
      font-weight: normal;
    }
  }
  .el-textarea {
    textarea {
      padding: 4px 8px;
    }
  }

  .upload-box {
    display: flex;
    $picSize: 60px;
    margin-top: 10px;
    .el-upload {
      width: $picSize;
      height: $picSize;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      margin-right: 10px;
    }
    .el-upload-list {
      li {
        position: relative;
        width: $picSize;
        height: $picSize;
      }
    }
  }
  .bar {
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    border-top: 1px solid #eee;
    background-color: #f5f5f5;
    .right {
      display: flex;
      align-items: center;
      svg {
        cursor: pointer;
        fill: #999999;
        font-size: 28px;
        padding: 0 5px;
      }
    }
    .el-tag {
      margin-left: 5px;
    }
    .btn {
      border-radius: 2px;
      font-size: 12px;
      padding: 2px 6px;
      cursor: pointer;
      white-space: nowrap;
    }
    .el-checkbox {
      padding: 0 5px;
      .el-checkbox__label {
        padding-left: 3px;
      }
    }
    .clear-btn {
      @extend .btn;
      background: linear-gradient(360deg, #f2f4f8 0%, #feffff 100%);
      border: 1px solid #ced0da;
      color: #808080;
      margin-right: 5px;
    }
    .send-btn {
      @extend .btn;
      padding-right: 10px;
      padding-left: 10px;
      margin-left: 10px;
      background-color: #4caf50;
      color: #fff;
    }
    .upload-btn {
      display: inline-flex;
      .el-upload--picture-card {
        background-color: transparent;
        border: none;
        width: auto;
        height: auto;
        line-height: inherit;
        i {
          font-size: inherit;
          color: #333;
        }
      }
      ul {
        display: none;
      }
    }
  }
  .tool-box {
    display: flex;
    font-size: 12px;
    max-width: 280px;
    .el-tag {
      display: inline-flex;
      align-items: center;
      background-color: #e3f2fd;
      border-color: #90caf9;
      color: #0091ea;
      span {
        display: block;
        max-width: 100px;
      }
      .el-tag__close {
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.emoji-picker {
  min-width: 50px !important;
  padding: 0 !important;
  .list {
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-button {
      margin-left: 0;
      width: 100%;
      border: none;
      height: 40px;
    }
  }
}
.tags-popover {
  min-width: 100px !important;
  i {
    display: inline-block;
    height: 100%;
  }
  .tags-box {
    line-height: 30px;
    > div {
      &:hover {
        background: #ee7700;
        color: #fff;
      }
      text-align: center;
    }
  }
}
.quick-dialog {
  .el-dialog__header {
    display: none;
    padding: 0;
  }
  .el-dialog__body {
    padding: 5px;
  }
}
</style>
